export default {
    methods: {
      /**
       * @deprecated Use getFolder instead
       */
        async getFolderByCode(code) {
            await this.$store.dispatch('fetchFolders', {
                apolloClient: this.$apolloProvider.defaultClient,
                getVisibleFolders: !!this.getVisibleFolders,
                practiceId: this.practiceId,
                emptyHidden: this.emptyHidden
            })
            return this.folders.find(({code: c}) => c == code)
        },
        async getFolder(code) {
            await this.$store.dispatch('fetchFoldersByCode', {
                apolloClient: this.$apolloProvider.defaultClient,
                folderCode: code
            })
            // there should only be one folder with the given code
            return this.folders.at(0)
        }
    }
}
